export const INITIAL_RESULT = 'initialResult';
